import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow notifications.
 */
export class NotificationOperations {
  constructor(private client: BaserowClient) {}
  
  // Notification methods will be implemented here
} 